export default __webpack_public_path__ + "static/media/sulfite.b76cb160.svg";